import { gql } from "@apollo/client";

const schema = {
  delete: {
    name: "deleteImportError",
    serviceName: "admin",
    query: gql`
      mutation deleteImportError($ids: [String]!) {
        deleteImportError(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
